import { PriorityProvider } from "@faire/retailer-visitor-shared/components/PriorityRenderer/PriorityStore";
import React, { PropsWithChildren } from "react";

export const PriorityRenderer: React.FC<PropsWithChildren> = ({ children }) => {
  return <PriorityProvider>{children}</PriorityProvider>;
};
